import React, { useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import useAuth from "./useAuth";
import { Loader } from "app";

const BidderAuthWrapper = function (props: { children: any }) {
  const { token, authCheckComplete, onboardingStatus } = useAuth();

  if (process.env.NEXT_PUBLIC_ENABLE_FEATURE === "true") {
    // New implementation
    if (!authCheckComplete || !token || token?.isLoggedIn === false) {
      // return (
      //   <main className="justify-center max-w-7xl mx-auto flex flex-col items-center min-h-screen">
      //     <Loader height="h-16" width="w-16" color="text-blue-600" />
      //   </main>
      // );
      return <div>{props.children}</div>;
    } else if (!onboardingStatus) {
      return (
        <main className="justify-center max-w-7xl mx-auto flex flex-col items-center min-h-screen">
          {/* Show bidder onboarding form */}
          <div>User is not onboarded</div>
        </main>
      );
    } else {
      return <div>{props.children}</div>;
    }
  } else {
    // Production code
    if (!authCheckComplete || !token) {
      return (
        <main className="justify-center max-w-7xl mx-auto flex flex-col items-center min-h-screen">
          <Loader height="h-16" width="w-16" color="text-brand-orange" />
        </main>
      );
    } else if (token && token?.isLoggedIn === false) {
      return <div>{props.children}</div>;
    } else {
      return <div>{props.children}</div>;
    }
  }
};

export default BidderAuthWrapper;
